import useAxiosInterceptor from 'src/services/interceptor';

class DocumentBundleService {
  private axiosInstance;

  constructor() {
    // `useAxiosInterceptor` is an axios-instance factory, not a React hook -- it calls no
    // hooks itself. The `use` prefix is what trips the rule here.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    this.axiosInstance = useAxiosInterceptor();
  }

  getPayerFilters = (params: Record<string, string>) =>
    this.axiosInstance.get('/provider/documents/filters/payers', { params });

  // SQ-171: therapists with documents in the window, with resident counts.
  getTherapistFilters = (params: Record<string, string>) =>
    this.axiosInstance.get('/provider/documents/filters/therapists', { params });

  getPatientFilters = (params: Record<string, string | string[]>) =>
    this.axiosInstance.get('/provider/documents/filters/patients', { params });

  // SQ-160: patient-first search. No date range — in this mode the dates are not
  // chosen until after a resident is picked, which is why /filters/patients cannot serve it.
  searchPatients = (params: Record<string, string | number>) =>
    this.axiosInstance.get('/provider/documents/patients/search', { params });

  // SQ-161: stays and payer coverage as two independent interval lists.
  getPatientIntervals = (patientUuid: string) =>
    this.axiosInstance.get(`/provider/documents/patients/${patientUuid}/intervals`);

  // SQ-162: the document rows themselves, so the on-screen count is the list's length.
  getPatientDocuments = (patientUuid: string, params: Record<string, string | string[]>) =>
    this.axiosInstance.get(`/provider/documents/patients/${patientUuid}/documents`, { params });

  getDocumentSummary = (body: Record<string, string | string[]>) =>
    this.axiosInstance.post('/provider/documents/available', body);

  getDownloadJobs = () => this.axiosInstance.get('/provider/documents/download-jobs');

  submitDownloadJob = (body: object) =>
    this.axiosInstance.post('/provider/documents/download-jobs', body);

  getPresignedUrl = (jobId: string) =>
    this.axiosInstance.post(`/provider/documents/download-jobs/${jobId}/presigned-url`);

  cancelDownloadJob = (jobId: string) =>
    this.axiosInstance.patch(`/provider/documents/download-jobs/${jobId}/cancel`);
}

const documentBundleService = new DocumentBundleService();
Object.freeze(documentBundleService);
export default documentBundleService;
